export default __webpack_public_path__ + "static/media/jyothisThreesa.82faf890.jpg";